var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadStatement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_385_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0032 50.0002C20.058 50.0009 15.2236 48.5348 11.1117 45.7876C6.99971 43.0403 3.7949 39.1353 1.90262 34.5664C0.0103452 29.9974 -0.48439 24.97 0.481 20.1199C1.44639 15.2697 3.82853 10.8149 7.3261 7.3188C12.0148 2.63015 18.3739 -0.00390625 25.0047 -0.00390625C31.6354 -0.00390625 37.9946 2.63015 42.6832 7.3188C47.3719 12.0074 50.0059 18.3666 50.0059 24.9974C50.0059 31.6281 47.3719 37.9873 42.6832 42.6759C40.367 45.0052 37.6117 46.8519 34.5769 48.1091C31.5421 49.3663 28.2881 50.0091 25.0032 50.0002ZM13.7504 35.2931V38.5352H36.4647V35.2931H13.7504ZM13.7504 20.6924L25.1075 32.0402L36.4647 20.6924H29.9782V10.9574H20.2432V20.6952H13.7504V20.6924Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_385_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadStatement);
export default __webpack_public_path__ + "static/media/download_statement.e0de75f0362d9e517e08c9758af80620.svg";
export { ForwardRef as ReactComponent };